var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoosty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 158.5 190.4",
    style: {
      enableBackground: "new 0 0 158.5 190.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,113.9L38.6,1h50.1L78.6,36c-0.1,0.2-0.2,0.4-0.3,0.6L51.7,129h24.8c-10.4,25.9-18.5,46.2-24.3,60.9 c-45.8-0.5-58.6-33.3-47.4-72.1 M52.4,190l60.4-86.9H87.2l22.3-55.7c38.2,4,56.2,34.1,45.6,70.5C143.8,157,98,190,53.4,190 C53,190,52.7,190,52.4,190z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosty);
export default __webpack_public_path__ + "static/media/boosty.3296cfc75e427f6817bbe42fdd7f4a8d.svg";
export { ForwardRef as ReactComponent };